import { Stack, Text, Title } from "@mantine/core";
import { AppWebviewButton } from "./AppWebviewButton";
import classes from "./appWebviewShared.module.css";
import { askSam } from "./askSam";

const QUESTIONS = [
  "Vad kan jag påverka i min pension?",
  "Vad är en kollektivavtalad pension?",
  "Vad är tjänstepension?",
];

export function AskSamSuggestions() {
  return (
    <Stack gap="sm" className={classes.purpleCard}>
      <Title
        order={2}
        fz="h4"
        lh="h4"
        ff="var(--wallet-font-family-sambla-sans)"
      >
        Fråga Sam om pension
      </Title>
      <Text size="sm" lh={1.5}>
        Sam kan hjälpa dig med de funderingar du har kring pension. Välj en
        fråga så öppnas AI-chatten med ett svar direkt.
      </Text>
      {QUESTIONS.map((question) => (
        <AppWebviewButton card key={question} onClick={() => askSam(question)}>
          {question}
        </AppWebviewButton>
      ))}
      <AppWebviewButton card onClick={() => askSam()}>
        Ställ en egen fråga
      </AppWebviewButton>
    </Stack>
  );
}
